<template>
  <div class="page-order">
    <div class="common" :class="{ active: active === 'common' }">
      <div class="banner ban_title">
        <h1>购买门票</h1>
        <button><a @click="openCode">优惠购票</a></button>
      </div>

      <div class="pc pc_content">
        <div class="main con">
          <h2>选择门票</h2>
          <p class="h2">CHOOSE TICKETS</p>
          <div class="alltic pc">
            <table>
              <tr class="caption">
                <td class="t1">门票名称</td>
                <td class="t2">优惠单价/原价</td>
                <td class="t3">说明</td>
                <td class="t4">数量</td>
              </tr>
              <tr
                v-for="(item, index) in alldata"
                :class="[choosed == index ? 'active' : '']"
                id="item"
                :key="'alltic_tr_' + index"
              >
                <td class="t1">{{ item.title }}</td>
                <td class="t2">
                  ￥{{ item.price }}&nbsp;/&nbsp;
                  <span>￥{{ item.originalPrice }}</span>
                  （元 / 张）
                </td>
                <td class="t3">{{ item.description }}</td>
                <td class="t4">
                  <button
                    class="a1"
                    @click="reduce(index)"
                    v-bind:disabled="item.num === 0"
                  >
                    -
                  </button>
                  <span class="tsspan">{{ item.num }}</span>
                  <button class="a2" v-on:click="add(index)">+</button>
                </td>
              </tr>
            </table>

            <div class="bttn">
              <div class="ri">
                <p>总计</p>
                <h1>￥{{ Price }}</h1>
                <div class="weibu">
                  <p>
                    <span v-if="islogin===false">购买门票前请先<a @click="toLogin()">登录</a><br></span>
                    提示：将跳转到 msup 统一订单结算中心
                  </p>
                  <div class="btnfirst morebtn" style="width: 150px">
                    <a v-on:click="tolink" style="width: 150px; color: #ffffff">立即支付</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mainwap mob pc_content">
        <div class="con">
          <h2>选择门票</h2>
          <p class="h2">CHOOSE TICKETS</p>
          <div
            class="single"
            v-for="(itemf, indexf) in alldata"
            :class="choosed == indexf ? 'activef' : ''"
            id="single"
            :key="'order_single_' + indexf"
          >
            <div class="top">
              <div class="le">
                <div>
                  <img
                    src="../assets/img/order02.png"
                    v-show="!(choosed == indexf)"
                  />
                  <img
                    src="../assets/img/order01.png"
                    v-show="choosed == indexf"
                  />
                </div>
                <p>{{ itemf.title }}</p>
              </div>
              <div class="ri">
                <button
                  v-on:click="reduce(indexf)"
                  v-bind:disabled="itemf.num === 0"
                >
                  -
                </button>
                <p>{{ itemf.num }}</p>
                <button v-on:click="add(indexf)">+</button>
              </div>
            </div>
            <div class="min">
              <div class="pri">
                <p>￥</p>
                <h1>{{ itemf.price }}</h1>
                <span>（元 / 张）</span>
              </div>
              <h2>￥{{ itemf.originalPrice }}</h2>
              <h3>{{ itemf.description }}</h3>
            </div>
          </div>
        </div>
      </div>

      <div class="faq pc_content">
        <div class="faqz con">
          <h2>FAQ</h2>
          <p class="h2">FAQ</p>
          <div class="intro">
            <div class="title_ts title_ts1">
              <div></div>
              <h1>购票说明</h1>
            </div>
            <p v-if="global.area_id=='4124'">
              1、由票务支持单位全程为您提供咨询和服务
              <br />2、票务支持单位：麦思博（北京）软件技术有限公司、北京清览教育科技有限公司等其他支持单位
              <br />3、对公账户：91240154800002818 等其他支持单位
              <br />
            </p>
            <p v-else-if="global.area_id=='4488'">
              1、由票务支持单位全程为您提供咨询和服务
              <br />2、票务支持单位：麦思博（北京）软件技术有限公司、天津易迪思信息科技有限公司等其他支持单位
              <br />3、对公账户：91240154800002818等其他支持单位
              <br />
            </p>
            <p v-else>
              1、由票务支持单位全程为您提供咨询和服务
              <br />2、票务支持单位：麦思博（北京）软件技术有限公司
              <br />3、对公账户：91240154800002818
              <br />
            </p>
            <div class="title_ts">
              <div></div>
              <h1>参会流程</h1>
            </div>
            <p>1、登录msup会议助手小程序、或官网会员中心（www.msup.com.cn/site/login）<br
              >2、查看已购，激活门票 <br />3、于{{ time }}持电子门票到现场即签到可获得入场凭证 <br
              >4、进入会场听课</p>
            <div class="title_ts">
              <div></div>
              <h1>支付方式</h1>
            </div>
            <p>1、在线支付：支付宝，微信<br
              >2、如您需要使用其他方式支付，请联系：400-8128-020</p>
            <div class="title_ts">
              <div></div>
              <h1>发票开具流程说明</h1>
            </div>
            <p>1、确认订单支付成功；<br
              >2、工作人员与购票方联系人及时通过邮件沟通发票信息，请购票方确认发票信息100%无误；<br
              >3、在无外力因素的情况下，发票将在7个工作日开具并快递；<br
              >4、会务组规定，在收到购票方票款后，方可按照实际总金额开具，如您有特殊需求，可及时找主办方沟通；<br
            ></p>
            <div class="title_ts">
              <div></div>
              <h1>退票说明</h1>
            </div>
            <p>1、如您在购票后因故不能参加大会，请至少提前7个工作日将门票转让他人（转让门票请联系本次活动的主办方进行票务信息<br />更改，会议开始前7个工作日内不接受转让门票。）<br
              >2、电子门票是大会现场换取入场证的唯一凭证，请妥善保管。<br
              >3、如果门票遗失，登录链接查看。（www.msup.com.cn/site/login）<br
              >4、遇到极端情况会议取消，主办方责任仅限于退回已支付的票款。</p>
          </div>
          <a>如果有任何问题，请联系:400-8128-020</a>
        </div>
      </div>

      <div class="mob jiez">
        <button class="btn_order_" v-on:click="tolink">立即支付</button>
        <p>总计：<span>￥{{ Price }}</span></p>
        <p class="tips" v-if="islogin===false">购买门票前请先<a @click="toLogin()">登录</a></p>
      </div>

      <div class="cover-layer" :class="{ show: show }">
        <div class="login-wrapper">
          <div class="login_phone">
            <div class="banner mob">
              <div class="banner_min mob">
                <!-- <img src="@/public/wap_login_phone.png" width="100%" /> -->
              </div>
            </div>
            <div class="backbg">
              <div class="top pc">
                <!-- <img src="@/public/login_phone.png" /> -->
              </div>
              <div class="middle">
                <input type="text" placeholder="手机号" class="phone_input" v-model="phone_number" />
                <div class="code">
                  <input type="text" placeholder="验证码" v-model="code" />
                  <div class="send_code" v-on:click="getCode">
                    <button :disabled="isdisabledFn">{{ codename }}</button>
                  </div>
                </div>
                <div class="login_btn" v-on:click="login">
                  <button>登录</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="login-close" @click="show = false"></div>
      </div>
    </div>

    <!-- 渠道优惠 系下方iframe -->
    <div class="special" :class="{ active: active === 'special' }" v-if="0">
      <div class="banner ban_title">
        <h1>{{ (specialdata && specialdata[0] && specialdata[0].title) || '购买门票' }}</h1>
        <p>由msup&reg;提供票务支持</p>
      </div>
      <div class="pc pc_content">
        <div class="main con">
          <h2>选择门票</h2>
          <p class="h2">CHOOSE TICKETS</p>
          <div class="alltic pc">
            <table>
              <tr class="caption">
                <td class="t1">门票种类</td>
                <td class="t2">优惠单价/原价</td>
                <!-- <td class="t3">说明</td> -->
                <td class="t4">数量</td>
              </tr>
              <tr id="item" v-for="(item, index) in specialdata" :class="[choosed == index ? 'active' : '']" :key="'alltic_s_tr_' + index">
                <td class="t1">{{ item.goodsName || item.title }}</td>
                <td class="t2"
                >￥{{ item.amount }}&nbsp;/&nbsp;<span
                >￥{{ item.price }}</span>（元 / 张）</td>
                <!-- <td class="t3">{{ item.description }}</td> -->
                <td class="t4">
                  <button class="a1" @click="reduce(index)" :disabled="item.num === 0">-</button>
                  <span class="tsspan">{{ item.num }}</span>
                  <button class="a2" @click="add(index)" :disabled="item.maxBuyNum > 0 && item.num === item.maxBuyNum">+</button>
                </td>
              </tr>
            </table>
            <div class="bttn">
              <div class="le">
                <div class="info-group">
                  <label>姓&emsp;名：</label>
                  <input type="text" v-model="userInfo.name" placeholder class="name">
                </div>
                <div class="info-group">
                  <label>公&emsp;司：</label>
                  <input type="text" v-model="userInfo.company" placeholder class="company">
                </div>
                <div class="info-group">
                  <label>邮&emsp;箱：</label>
                  <input type="text" v-model="userInfo.email" placeholder class="email">
                </div>
                <div class="info-group">
                  <label>手机号：</label>
                  <input type="text" v-model="userInfo.phone" placeholder class="phone">
                </div>
                <div class="info-group">
                  <label>验证码：</label>
                  <input type="text" v-model="userInfo.code" placeholder class="code">
                  <button @click="getCaptcha">{{ codename }}</button>
                </div>
                <div class="info-group">
                  <label>发票信息：</label>
                  <textarea name="user-invoice" v-model="userInfo.invoice" placeholder class="invoice"></textarea>
                </div>
              </div>
              <div class="ri">
                <p>总计</p>
                <h1>￥{{ Price }}</h1>
                <div class="weibu">
                  <!-- <p><span v-if="islogin===false">购买门票前请先<a @click="toLogin()">登录</a><br></span></p> -->
                  <p>提示：将跳转到 msup 统一订单结算中心</p>
                  <div class="btnfirst morebtn" style="width: 150px">
                    <a @click="tolink" style="width: 150px; color: #ffffff">立即支付</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mainwap mob pc_content">
        <div class="con">
          <h2>选择门票</h2>
          <p class="h2">CHOOSE TICKETS</p>
          <p class="step">Step1:选择门票种类和购买数量</p>
          <div
            class="single"
            v-for="(itemf, indexf) in specialdata"
            :class="choosed == indexf ? 'activef' : ''"
            id="single"
            :key="'order_single_' + indexf"
          >
            <div class="top">
              <div class="le">
                <div>
                  <img src="../assets/img/order02.png" v-show="!(choosed == indexf)" />
                  <img src="../assets/img/order01.png" v-show="choosed == indexf" />
                </div>
                <p>{{ itemf.goodsName || itemf.title }}</p>
              </div>
              <div class="ri">
                <button @click="reduce(indexf)" v-bind:disabled="itemf.num === 0">-</button>
                <p>{{ itemf.num }}</p>
                <button @click="add(indexf)">+</button>
              </div>
            </div>
            <div class="min">
              <div class="pri">
                <p>￥</p>
                <h1>{{ itemf.amount }}</h1>
                <span>（元 / 张）</span>
              </div>
              <h2>￥{{ itemf.price }}</h2>
              <h3>{{ itemf.description }}</h3>
            </div>
          </div>
          <div class="step-2">
            <p class="step">Step2:填写购票人信息<span
            >支付成功后，您可以使用手机号登录我们官网、msup会议助手小程序、或者官方公众号的会员中心查看您的购票信息</span></p>
            <div class="info-group">
              <label>姓&emsp;名：</label>
              <input type="text" v-model="userInfo.name" placeholder class="name">
            </div>
            <div class="info-group">
              <label>公&emsp;司：</label>
              <input type="text" v-model="userInfo.company" placeholder class="company">
            </div>
            <div class="info-group">
              <label>邮&emsp;箱：</label>
              <input type="text" v-model="userInfo.email" placeholder class="email">
            </div>
            <div class="info-group">
              <label>手机号：</label>
              <input type="text" v-model="userInfo.phone" placeholder class="phone">
            </div>
            <div class="info-group">
              <label>验证码：</label>
              <input type="text" v-model="userInfo.code" placeholder class="code">
              <button @click="getCaptcha">{{ codename }}</button>
            </div>
            <div class="info-group">
              <label>发票信息：</label>
              <textarea name="user-invoice" v-model="userInfo.invoice" placeholder class="invoice"></textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="mob jiez">
        <button class="btn_order_" @click="tolink">立即支付</button>
        <p>总计：<span>￥{{ Price }}</span></p>
        <!-- <p class="tips" v-if="islogin===false">购买门票前请先<a @click="toLogin()">登录</a></p> -->
      </div>
    </div>

    <iframe
      id="order_iframe"
      v-if="active === 'special'"
      :class="{ active: active === 'special' }"
      :src="`https://case.msup.com.cn/pay/pay-submit.html?hash=${hash}`"
    ></iframe>

    <a
      id="qd_link"
      v-if="active === 'special'"
      :href="`https://case.msup.com.cn/pay/pay-submit.html?hash=${hash}`"
      style="display:none;"
    ></a>

    <!-- new:优惠码输入框 -->
    <div class="code-con" v-if="showCode" @click="openCode">
      <div class="code-box" @click="stopPropagation">
        <h1>优惠购票</h1>
        <input type="text" id="order-code-input" v-model="preCode" placeholder="请输入优惠码" />
        <div class="flex-wrap">
          <button @click="openCode">取消</button>
          <button @click="confirmCode">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mixinSession } from '../mixin'

export default {
  name: 'Order',
  mixins: [mixinSession],
  data () {
    return {
      showCode: false, // 控制优惠吗码输入框的显示/隐藏
      preCode: '', // 优惠码
      token: '',
      islogin: false,
      active: 'common',
      alldata: [],
      specialdata: [],
      num: 0,
      Price: 0,
      choosed: 100000,
      share: '',
      params: '',
      show: false,
      phone_number: '',
      codename: '发送验证码',
      isdisabledFn: false,
      code: '',
      iswechat: true,
      wxId: '',
      loginTerminal: 1,
      phoneOS: 0,
      phoneReg: /^1[0-9]{10}$/,
      time: '',
      hash: undefined,
      userInfo: { phone: '', name: '', company: '', email: '', code: '', invoice: '' }
    }
  },
  watch: {
    active: {
      handler (_new, _old) {
        if (_new && _new === 'special') {
          console.log('active ', _new, _old, this.hash)
          this.$nextTick(() => {
            // console.log('active ', _new, _old, document.getElementById('qd_link'))
            // if (document.getElementById('qd_link')) {
            //   document.getElementById('qd_link').click() // 》》》》》》 <div class="special" ...>...</div>
            // }
            const qd = this.preCode || this.params.qd
            this.$router.replace(this.formatHref('/code', {qd}))
          })
        }
      },
      immediate: true,
      deep: true
    }
  },
  created () {
    this.token = localStorage.getItem('token')
    this.islogin = Boolean(this.token && this.token.trim() !== '')
    // this.checkUserInfo();
    // 获取数据
    this.getPlace()
    this.params = this.$route.query
    // if (this.global.hashParam["share"]) {
    //   localStorage.setItem("share", this.global.hashParam["share"]||'');
    // }
    this.getTicketData()
    var isPC = this.global.IsPC()
    if (isPC) {
      this.loginTerminal = 1
    } else {
      var ua = navigator.userAgent.toLowerCase()
      var isWeixin = ua.indexOf('micromessenger') !== -1
      if (isWeixin) {
        this.loginTerminal = 3
      } else {
        this.loginTerminal = 2
        this.mob_show_img = false
      }
      // 判断手机系统
      var u = navigator.userAgent
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // android终端
      if (isiOS) {
        this.phoneOS = 2
      } else if (isAndroid) {
        this.phoneOS = 1
      }
    }
  },
  mounted () {
    this.isHashTrue()
  },
  methods: {
    getPlace: function () {
      let purl = this.global.urlNew.place + this.global.area_id
      this.$http
        .jsonp(purl)
        .then((res) => {
          return res.json()
        })
        .then((res) => {
          // console.log(res);
          if (res.status === 200 || res.status === '200') {
            this.time =
              this.global.formatTime(res.data.startTime, 'Y年M月D日') +
              '-' +
              this.global.formatTime(res.data.endTime, 'D日')
          }
        })
    },
    confirmCode () {
      console.log('preCode ', this.preCode)
      if (!this.preCode) {
        this.$message.closeAll()
        this.$message({ message: '请输入优惠码', type: 'warning' })
        // eslint-disable-next-line no-undef
        $('#order-code-input').focus()
        return false
      }
      // 优惠码校验
      this.isHashTrue(this.preCode)
    },
    openCode () {
      this.showCode = !this.showCode
      if (this.showCode) {
        setTimeout(() => {
          // eslint-disable-next-line no-undef
          $('#order-code-input').focus()
        }, 100)
      }
    },
    stopPropagation (e) {
      e.stopPropagation()
    },
    // 判断hash是否合格 &qd=5cOv1oOX
    isHashTrue (_hash) {
      // const qd = window.localStorage.getItem("mpd-qd");
      const qd = this.preCode || this.params.qd
      this.hash = this.global.hashParam['qd'] || qd
      if (!this.hash) {
        return false
      }
      let url = this.global.urlNew.checkHash + '?hash=' + (_hash || this.hash)
      this.$http.jsonp(url)
        .then((data) => {
          return data.json()
        })
        .then((res) => {
          if (res.status === 200 || res.status === '200') {
            this.active = 'special'
            this.getHashData()
          } else {
            this.active = 'common'
            if (this.showCode) {
              this.$message.closeAll()
              this.$message({ message: '优惠码无效', type: 'warning' })
            }
          }
        })
    },
    getHashData () {
      let url = this.global.urlNew.special + '?hash=' + this.hash
      this.$http.jsonp(url)
        .then((data) => {
          return data.json()
        })
        .then((res) => {
          // console.log('special_data ', res)
          this.specialdata = []
          if (res.status === 200 || res.status === '200') {
            if (typeof res.data === 'object') {
              if (Array.isArray(res.data)) {
                this.specialdata = [ ...res.data ]
              } else {
                this.specialdata = [ { ...res.data } ]
              }
            }
          }
          for (let index in this.specialdata) {
            this.specialdata[index].minBuyNum = parseInt(this.specialdata[index].minBuyNum || 0)
            this.specialdata[index].maxBuyNum = parseInt(this.specialdata[index].maxBuyNum || 0)
            this.specialdata[index].index = parseInt(index)
            this.specialdata[index].num = 0
          }
          if (this.specialdata.length === 1) {
            this.choosed = 0
            this.specialdata[0].num = this.specialdata[0].minBuyNum || 1
            this.Price = this.specialdata[0].amount * this.specialdata[0].num
          }
        })
    },
    // 判断是否是手机端
    isMobile: function () {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return flag
    },
    // 获取验证码
    getCode: function () {
      var phone = this.phone_number
      var myreg = /^1[0-9]{10}$/
      var _this = this
      if (!phone || phone.toString().trim() === '') {
        alert('手机号不能为空')
        return false
      } else if (!myreg.test(phone)) {
        alert('请输入正确的手机号')
        this.phone_number = ''
        return false
      } else {
        // var url =
        //   this.global.urlNew[this.global.area_id].login.login_phone.getcode + phone;
        let url = this.global.urlNew['sendCode'] + '?phone=' + phone
        this.$http
          .jsonp(url)
          .then((data) => {
            return data.json()
          })
          .then((data) => {
            if (data.code === 200 || data.code === '200') {
              var num = 61
              var timer = setInterval(function () {
                num--
                if (num <= 0) {
                  clearInterval(timer)
                  _this.codename = '重新发送'
                  _this.isdisabledFn = false
                } else {
                  _this.codename = num + 's'
                  _this.isdisabledFn = true
                }
              }, 1000)
            } else {
              this.$toast('发送验证码失败，请重试')
            }
          })
      }
    },
    getCaptcha (e) {
      // eslint-disable-next-line no-undef
      if (!$(e.target).attr('disabled')) {
        // eslint-disable-next-line no-undef
        $(e.target).attr({'disabled': 'disabled'}) // 防止重复点击
        var phone = this.userInfo.phone
        var myreg = /^1[0-9]{10}$/
        if (!phone || phone.toString().trim() === '') {
          this.$toast('手机号不能为空')
          // eslint-disable-next-line no-undef
          $(e.target).removeAttr('disabled')
          return false
        } else if (!myreg.test(phone)) {
          this.$toast('请输入正确的手机号')
          this.userInfo.phone = ''
          // eslint-disable-next-line no-undef
          $(e.target).removeAttr('disabled')
          return false
        } else {
          let url = this.global.urlNew['sendCaptcha'] + '?phone=' + phone
          this.$http
            .jsonp(url)
            .then((data) => {
              return data.json()
            })
            .then((data) => {
              if (data.code === 200 || data.code === '200') {
                this.$toast('已发送')
                // this.codename = '重新发送'
                var num = 61
                var timer = setInterval(() => {
                  num--
                  if (num <= 0) {
                    clearInterval(timer)
                    this.codename = '重新发送'
                    // eslint-disable-next-line no-undef
                    $(e.target).removeAttr('disabled')
                  } else {
                    this.codename = num + 's后发送'
                  }
                }, 1000)
              } else {
                this.$toast('发送失败')
                this.codename = '发送验证码'
                // eslint-disable-next-line no-undef
                $(e.target).removeAttr('disabled')
              }
              // eslint-disable-next-line no-undef
              // $(e.target).removeAttr('disabled')
            })
        }
      }
    },
    // 手机号登录方式
    login: function () {
      var phone = this.phone_number
      var code = this.code
      var myreg = /^1[0-9]{10}$/
      if (!phone || phone.toString().trim() === '') {
        this.$toast('手机号不能为空')
        return false
      }
      if (!myreg.test(phone)) {
        alert('请输入正确的手机号')
        this.phone_number = ''
        return false
      }
      if (!code || code.toString().trim() === '') {
        alert('验证码不能为空')
        return false
      }
      let url =
        this.global.urlNew.checkCaptcha +
        '?phone=' +
        phone +
        '&captcha=' +
        this.code +
        '&loginTerminal=' +
        this.loginTerminal +
        '&phoneOS=' +
        this.phoneOS
      // var url=this.global.urlNew[this.global.area_id].login.login_phone.login+phone+'/'+code+'?wxId='+this.wxId;
      this.$http
        .jsonp(url)
        .then((data) => {
          return data.json()
        })
        .then((data) => {
          if (data.code === '200') {
            // this.global.changeLogined();
            localStorage.setItem('logins', true)
            localStorage.setItem('token', data.data.token)
            this.$toast('登录成功')
            // this.global.isLogined()
            this.show = false
            this.$router.go(0)
          } else {
            this.$toast(data.data.msg)
          }
        })
    },
    //
    getTicketData () {
      var url = this.global.urlNew.order + '?sid=' + this.global.area_id
      var isshare = !!(localStorage.getItem('share') && !['undefined', 'null'].includes(localStorage.getItem('share')))
      url += isshare ? ('&share=' + localStorage.getItem('share')) : ''
      // console.log(url)
      this.$http.jsonp(url)
        .then((data) => {
          return data.json()
        })
        .then((data) => {
          // console.log(url, data)
          if (data.errno === 0 || data.errno === '0') {
            for (var i = 0; i < data.data.length; i++) {
              this.alldata.push({
                description: data.data[i].description,
                id: data.data[i].id,
                originalPrice: data.data[i].originalPrice || data.data[i].newPrice,
                price: data.data[i].newPrice,
                sid: data.data[i].sid,
                title: data.data[i].title,
                num: 0,
                minNumber: parseInt(data.data[i].minNumber),
                index: i
              })
            }
            // console.log(this.alldata)
          }
        })
    },
    totalPrice: function (f) {
      if (this.active === 'special') {
        this.Price = this.specialdata[f].amount * this.specialdata[f].num
      } else {
        this.Price = this.alldata[f].price * this.alldata[f].num
      }
    },
    // 生成订单，成功后跳转收银台
    toLogin (_link) {
      let link = _link || this.$route.fullPath || '/order'
      // this.show = true;
      window.localStorage.removeItem('logins')
      window.localStorage.removeItem('token')
      this.global.isLogined()
      // let preLink = link || window.location.href;
      let preLink = link || (window.location.pathname + window.location.search)
      window.localStorage.setItem('linkurl', preLink)
      this.$router.push(this.formatHref('/login'))
    },
    tolink (e) {
      if (this.choosed && parseInt(this.choosed) === 100000) {
        this.$toast('您还没有选择门票')
        return
      }
      if (this.active === 'special') {
        this.toLinkSpecial(e)
      } else {
        this.toLinkCommon(e)
      }
    },
    toLinkCommon (e) {
      // console.log($(e.target).attr('disabled'))
      // eslint-disable-next-line no-undef
      if (!$(e.target).attr('disabled')) {
        const token = this.token
        if (!token || token === null) {
          this.$toast('您未登录或当前登录状态已过期', 1000)
          setTimeout(() => {
            this.toLogin()
          }, 800)
          return
        }
        // if (this.choosed && parseInt(this.choosed) === 100000) {
        //   this.$toast('您还没有选择门票')
        //   return
        // }
        let ticketId = this.alldata[this.choosed].id
        let ticketNum = this.alldata[this.choosed].num
        if (ticketNum === 0 || ticketNum === '0') {
          this.$toast('请选择门票数量')
          return
        }
        // eslint-disable-next-line no-undef
        $(e.target).attr({'disabled': 'disabled'}) // 防止重复点击
        if (this.alldata[this.choosed].price === 0 || this.alldata[this.choosed].price === '0') {
          // 体验票
          this.$router.push(this.formatHref('/Getexper'))
        } else {
          // 购票 —> 有无渠道码/优惠码
          let baseParam = `?token=${token}&number=${ticketNum}&stid=${ticketId}`
          let url = this.global.urlNew['createOrder'] + baseParam
          let share = this.params.share
          let channel = this.params.qd
          if (share) {
            url += `&share=${share}`
          }
          // } else
          if (channel) {
            url += `&channel=${channel}`
          }
          this.createOrder(e, url)
        }
      }
    },
    toLinkSpecial (e) {
      // console.log($(e.target), $(e.target).attr('disabled'))
      // eslint-disable-next-line no-undef
      if (!$(e.target).attr('disabled') && this.specialdata[this.choosed]) {
        if (!this.userInfo.name || this.userInfo.name.toString().trim() === '') {
          this.$toast('请输入姓名')
          this.userInfo.name = ''
          return false
        }
        if (!this.userInfo.company || this.userInfo.company.toString().trim() === '') {
          this.$toast('请输入公司')
          this.userInfo.company = ''
          return false
        }
        if (!this.userInfo.email || this.userInfo.email.toString().trim() === '') {
          this.$toast('请输入邮箱')
          this.userInfo.email = ''
          return false
        }
        if (!this.userInfo.phone || this.userInfo.phone.toString().trim() === '') {
          this.$toast('请输入手机号')
          this.userInfo.phone = ''
          return false
        } else if (!this.phoneReg.test(this.userInfo.phone)) {
          this.$toast('手机号格式错误')
          this.userInfo.phone = ''
          return false
        }
        if (!this.userInfo.code || this.userInfo.code.toString().trim() === '') {
          this.$toast('请输入验证码')
          this.userInfo.code = ''
          return false
        }
        let { goodsId, amount, createdUser } = this.specialdata[this.choosed]
        let ticketNum = this.specialdata[this.choosed].num
        if (ticketNum === 0 || ticketNum === '0') {
          this.$toast('请选择门票数量')
          return
        }
        // eslint-disable-next-line no-undef
        $(e.target).attr({'disabled': 'disabled'}) // 防止重复点击
        if (this.specialdata[this.choosed].price === 0 || this.specialdata[this.choosed].price === '0') {
          // 体验票
          this.$router.push(this.formatHref('/Getexper'))
        } else {
          // 购票
          let baseParam = `?goodsId=${+goodsId}&phone=${this.userInfo.phone}&amount=${+amount}&number=${+ticketNum}&hash=${this.hash}&createUserId=${+createdUser}&name=${this.userInfo.name}&email=${this.userInfo.email}&company=${this.userInfo.company}&captcha=${this.userInfo.code}&&invoice=${this.userInfo.invoice}`
          let url = this.global.urlNew['createOrderGoods'] + baseParam
          this.createOrder(e, url)
        }
      }
    },
    createOrder (e, url) {
      this.$http
        .jsonp(url)
        .then((data) => {
          return data.json()
        })
        .then((res) => {
          console.log(url, res)
          if (res.status === '200' && res.data && res.data.orderNumber) {
            let nurl = ''
            if (this.active === 'special') {
              nurl = window.location.href.replace('/order', '/order_success')
              nurl += nurl.includes('?') ? '&order=' : '?order='
              nurl += res.data.orderNumber
            } else {
              nurl = window.location.href.replace('/order', '/user_center') // https%3A%2F%2F${nurl}%2Fuser_center
            }
            window.location.href = `${this.global.urlNew['payStands']}?order=${
              res.data.orderNumber
            }&refer=${encodeURIComponent(nurl)}`
          } else {
            if (this.active === 'special') {
              if (['1008', '1029', '1030', '1019'].includes(res.status)) {
                this.$toast(res.message)
              } else {
                this.$toast('订单创建失败')
              }
            } else {
              if (res.status === '1029') {
                this.$toast('创建订单失败，请稍后重试')
              } else if (res.status === '1004') {
                this.$toast('状态错误，请重新登录')
                this.toLogin()
              } else {
                this.$toast('网络错误，请重试')
              }
            }
          }
          setTimeout(() => {
            // eslint-disable-next-line no-undef
            $(e.target).removeAttr('disabled')
          }, 200)
        })
        .catch(res => {
          console.log('error ', res)
        })
    },
    add: function (e) {
      this.choosed = e
      if (e || e === 0) {
        if (this.active === 'special') {
          // this.specialdata[index].
          for (let i in this.specialdata) {
            let sIndex = (this.specialdata[i].index || this.specialdata[i].index === 0) ? this.specialdata[i].index : ''
            if (sIndex.toString().trim() === e.toString().trim()) {
              if (this.specialdata[i].maxBuyNum > 0 && this.specialdata[i].num >= this.specialdata[i].maxBuyNum) {
                this.$toast('已达到可购买的最大数量')
              } else if (this.specialdata[i].num >= this.specialdata[i].minBuyNum) {
                this.specialdata[i].num += 1
              } else {
                this.specialdata[i].num += this.specialdata[i].minBuyNum
              }
            } else {
              this.specialdata[i].num = 0
            }
          }
        } else {
          for (let i in this.alldata) {
            let aIndex = (this.alldata[i].index || this.alldata[i].index === 0) ? this.alldata[i].index : ''
            if (aIndex.toString().trim() === e.toString().trim()) {
              if (this.alldata[i].num >= this.alldata[i].minNumber) {
                this.alldata[i].num += 1
              } else {
                this.alldata[i].num += this.alldata[i].minNumber
              }
            } else {
              this.alldata[i].num = 0
            }
          }
        }
        this.$forceUpdate()
        this.totalPrice(e)
      }
    },
    reduce: function (e) {
      this.choosed = e
      if (e || e === 0) {
        if (this.active === 'special') {
          for (let i in this.specialdata) {
            let sIndex = (this.specialdata[i].index || this.specialdata[i].index === 0) ? this.specialdata[i].index : ''
            if (sIndex.toString().trim() === e.toString().trim()) {
              if (this.specialdata[i].num === this.specialdata[i].minBuyNum) {
                if (this.specialdata.length > 1) {
                  this.specialdata[i].num -= this.specialdata[i].minBuyNum
                } else {
                  this.$toast('不能再减少啦')
                }
              } else if (this.specialdata[i].num > 0) {
                this.specialdata[i].num -= 1
              }
            } else {
              this.specialdata[i].num = 1
            }
          }
        } else {
          for (let i in this.alldata) {
            let aIndex = (this.alldata[i].index || this.alldata[i].index === 0) ? this.alldata[i].index : ''
            if (aIndex.toString().trim() === e.toString().trim()) {
              if (this.alldata[i].num <= this.alldata[i].minNumber) {
                this.alldata[i].num -= this.alldata[i].minNumber
              } else {
                this.alldata[i].num -= 1
              }
            } else {
              this.alldata[i].num = 0
            }
          }
        }
        this.$forceUpdate()
        this.totalPrice(e)
      }
    },
    // getQueryString: function(name) {
    //  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    //  var r = window.location.search.substr(1).match(reg);
    //  if (r != null) return r[2];
    //  return null;
    // },
    // 检查个人信息
    checkUserInfo () {
      const token = this.token
      if (token && token !== null) {
        let url = `${this.global.urlNew.getUserSetting}?token=${token}`
        this.$http
          .jsonp(url)
          .then((data) => {
            return data.json()
          })
          .then((res) => {
            // console.log("order- checkInfo",res);
            if (res.status === '200') {
              for (const key in res.data) {
                if (!res.data[key] || res.data[key] === '') {
                  if (window.confirm('购票需要您先完善个人信息')) {
                    let link = window.location.pathname + window.location.search
                    localStorage.setItem('link_before_complete', link)
                    this.$router.push(this.formatHref('/user_center', { active: '5' }))
                  } else {
                    this.$router.push(this.formatHref('/home'))
                  }
                  break
                }
              }
            } else if (res.code === '1001' || res.status === '1011') {
              this.$toast('当前登录状态已过期，请重新登录')
              this.toLogin()
            } else {
              console.log('获取用户信息失败')
            }
          })
      } else {
        this.$toast('当前登录状态已过期，请重新登录')
        this.toLogin()
      }
    }
  }
}
</script>
<style lang="scss">
#app .page-order {
  width: 100%;
  position: relative;
  a,
  a:hover,
  a:active,
  a:link {
    text-decoration: none;
    color: #000000;
  }
  @media (max-width: 767px) {
    .jiez {
      width: 100%;
      height: 55px;
      line-height: 55px;
      background: #ffffff;
      position: fixed;
      z-index: 1;
      bottom: 0;
      border-top: 1.5px solid #e6e6e6;
      display: -webkit-box !important;  /* OLD - iOS 6-, Safari 3.1-6 */
      display: -moz-box !important;     /* OLD - Firefox 19- (buggy but mostly works) */
      display: -ms-flexbox !important;  /* TWEENER - IE 10 */
      display: -webkit-flex !important; /* NEW - Chrome */
      display: flex !important;
      flex-direction: row-reverse;
    }
    .jiez p {
      font-size: 16px;
      line-height: 55px;
      white-space: nowrap;
    }
    .jiez p span {
      font-size: 18px;
      font-weight: bold;
    }
    .jiez p.tips {
      width: 100%;
      text-align: center;
      color: var(--main-color-order);
    }
    .jiez p.tips a {
      display: inline-block;
      margin-left: 3px;
      padding-bottom: 3px;
      color: var(--main-color-order);
      border-bottom: 1px solid var(--main-color-order);
    }
    .jiez button {
      height: 45px;
      line-height: 45px;
      margin-top: 5px;
      /* background: var(--main-color-order); */
      /* color: #000000; */
      background: var(--deep-color);
      color: #ffffff;
      width: 90px;
      min-width: 90px;
      border: none;
      outline: none;
      margin-left: 15px;
      margin-right: 3px;
      font-weight: bold;
      font-size: 15px;
      /* border: none !important; */
    }
  }
  .single {
    width: 100%;
    border-radius: 15px;
    border: 1.5px solid #e6e6e6;
    box-shadow: 0px 0px 3px #ebebeb;
    padding: 20px 12px;
    margin-top: 15px;
  }
  .activef {
    border: 1.5px solid var(--main-color-order) !important;
    box-shadow: 0px 0px 3px #f3f0dd;
  }
  .single {
    .top {
      display: -webkit-box;  /* OLD - iOS 6-, Safari 3.1-6 */
      display: -moz-box;     /* OLD - Firefox 19- (buggy but mostly works) */
      display: -ms-flexbox;  /* TWEENER - IE 10 */
      display: -webkit-flex; /* NEW - Chrome */
      display: flex;
      justify-content: space-between;
      vertical-align: top;
      .le {
        display: -webkit-box;  /* OLD - iOS 6-, Safari 3.1-6 */
        display: -moz-box;     /* OLD - Firefox 19- (buggy but mostly works) */
        display: -ms-flexbox;  /* TWEENER - IE 10 */
        display: -webkit-flex; /* NEW - Chrome */
        display: flex;
        margin-top: 3px;
        img {
          width: 16px;
          vertical-align: top !important;
        }
        p {
          font-size: 16px;
          margin-left: 6px;
          line-height: 16px;
          height: 16px;
        }
      }
      .ri {
        width: 105px;
        border: 1px solid #cccccc;
        border-radius: 6px;
        display: -webkit-box;  /* OLD - iOS 6-, Safari 3.1-6 */
        display: -moz-box;     /* OLD - Firefox 19- (buggy but mostly works) */
        display: -ms-flexbox;  /* TWEENER - IE 10 */
        display: -webkit-flex; /* NEW - Chrome */
        display: flex;
        height: 35px;
        line-height: 30px;
        box-sizing: border-box;
        button {
          outline: none;
          width: 33.5%;
          text-align: center;
          color: #cccccc;
          line-height: 30px;
          font-weight: bold;
          border: none;
          background: none;
        }
        p {
          width: 33%;
          text-align: center;
          border-left: 1px solid #cccccc;
          border-right: 1px solid #cccccc;
          font-size: 16px;
          line-height: 35px;
          margin: 0;
        }
      }
    }
    .min {
      p {
        font-size: 20px;
        /* font-family: Montserrat Regular; */
        font-weight: bold;
        margin-left: 15px;
      }
      h1 {
        font-size: 32px;
        /* font-family: Montserrat Regular; */
        font-weight: bold;
        margin-top: 3px;
        margin-bottom: 0;
      }
      .pri {
        display: -webkit-box;  /* OLD - iOS 6-, Safari 3.1-6 */
        display: -moz-box;     /* OLD - Firefox 19- (buggy but mostly works) */
        display: -ms-flexbox;  /* TWEENER - IE 10 */
        display: -webkit-flex; /* NEW - Chrome */
        display: flex;
        margin-top: 3px;
        margin-bottom: 3px;
        span {
          height: 30px;
          line-height: 30px;
          font-size: 16px;
        }
      }
      h2 {
        font-size: 14px;
        font-weight: bold;
        /* font-family: Montserrat Regular; */
        color: #808080;
        text-decoration: line-through;
        margin-top: 0;
        margin-bottom: 0;
        margin-left: 17px;
      }
      h3 {
        margin-left: 17px;
        margin-top: 30px;
        font-size: 16px;
        /* font-family: Montserrat Regular; */
      }
    }
  }

  iframe, .common, .special {
    display: none;
    &.active {
      display: block;
    }
  }

  .common {
    padding-bottom: 30px;
  }

  .special {
    .banner.ban_title {
      display: grid;
      justify-content: center;
      align-content: center;
      align-items: center;
      h1 {
        height: auto;
        line-height: 1;
      }
      p {
        margin-top: 20px;
        font-size: 18px;
        font-weight: 400;
        color: #ffffff;
      }
    }
  }

  iframe {
    width: 100%;
    height: 1000px;
    /* height: calc(100vh - 130px);
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 10; */
    border: none;
  }
  @media (max-width: 767px) {
    iframe {
      height: 1200px;
    }
  }

  .main {
    width: 100%;
    max-width: 1250px;
    padding: 60px 25px 0px 25px;
    margin: 0 auto;
  }
  .alltic {
    margin-top: 44px;
    width: 100%;
    margin-bottom: 70px;
    table {
      width: 100%;
      box-shadow: 0px 0px 4px #dddddd;
      box-sizing: border-box;
    }
    table #item {
      border-bottom: 1px solid #dddddd;
      &:last-child {
        border-bottom: none;
      }
      .active {
        background: #dddddd;
      }
    }
  }
  .caption {
    td {
      height: 55px;
      line-height: 55px;
      background: var(--main-color-order);
      color: #ffffff;
      text-align: center;
      font-size: 18px;
      font-weight: 400;
    }
    .t1, .t4 {
      width: 20%;
    }
    .t2 {
      width: 28%;
    }
    .t3 {
      width: 32%;
    }
  }
  #item {
    td {
      height: 50px;
      padding: 10px 0px;
      line-height: 25px;
      text-align: center;
      font-size: 16px;
      color: #444444;
      /* color: #BBBBBB; */
    }
    .t2 {
      color: #333333;
    }
    .t2 span {
      color: #bbbbbb;
      text-decoration: line-through;
    }
    .a1,
    .a2 {
      width: 40px;
      height: 25px;
      line-height: 25px;
      display: inline-block;
      background: var(--main-color-order);
      color: #ffffff;
      font-size: 15px;
      font-weight: bold;
      border: none;
      outline: none;
    }
    .a1 {
      border-top-left-radius: 25px;
      border-bottom-left-radius: 25px;
    }
    .a2 {
      border-top-right-radius: 25px;
      border-bottom-right-radius: 25px;
    }
    .tsspan {
      font-size: 16px;
      margin: 0 10px;
      width: 20px;
      display: inline-block;
    }
  }
  .bttn {
    margin-top: 55px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    .le {
      width: 100%;
      max-width: 300px;
      display: grid;
      margin-right: 15px;
      padding-bottom: 15px;
      border-radius: 5px;
      border: 1px solid var(--main-color-order);
      background-color: #dddddd;
      &:before {
        content: '填写信息';
        display: block;
        width: 100%;
        padding: 15px 0;
        font-size: 16px;
        color: #ffffff;
        text-align: center;
        background-color: var(--main-color-order);
      }
      --text-line-height: 26px;
      .info-group {
        width: 100%;
        margin-top: 10px;
        padding: 0 15px;
        display: flex;
        align-items: flex-start;
        position: relative;
        z-index: 1;
        &:nth-of-type(1) {
          margin-top: 15px;
        }
        label {
          min-width: 75px;
          line-height: var(--text-line-height);
        }
        label, button {
          font-weight: 400;
          margin-top: 0;
          margin-bottom: 0;
        }
        button {
          width: 80px;
          line-height: calc(var(--text-line-height) - 2px);
          padding: 0 5px;
          font-size: 13px;
          font-weight: 400;
          color: #ffffff;
          position: absolute;
          right: 15px;
          z-index: 2;
          border-top-right-radius: 5px;
          border-bottom-right-radius: 5px;
          border: 1px solid #919191;
          border-left: none;
          background: var(--main-color-order); // #dddddd;
        }
        input, textarea {
          width: 100%;
          padding: 0 5px;
          outline: none;
          border-radius: 5px;
          border: 1px solid #919191;
        }
        input {
          height: var(--text-line-height);
          &.code {
            padding-right: 85px;
          }
        }
        textarea {
          height: calc(var(--text-line-height) * 2 - 2px);
        }
      }
    }
    .ri {
      width: 100%;
      text-align: right;
    }
    label, button, p {
      white-space: nowrap;
      font-size: 16px;
      color: #4c4c4c;
    }
    h1 {
      font-size: 30px;
      margin-top: 15px;
    }
  }
  .btnfirst {
    height: auto;
    margin-top: 0;
    display: inline-block;
  }
  .btnfirst.morebtn a {
    padding: 0;
    line-height: 50px;
    border-radius: 0;
  }
  .weibu {
    margin-top: 30px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    p {
      font-size: 16px;
      color: #222222;
      font-weight: 400;
      margin-right: 20px;
      margin-top: 0;
      margin-bottom: 0;
      span {
        display: block;
        margin-bottom: 3px;
        color: var(--main-color-order);
        a, a:hover, a:visited {
          display: inline-block;
          margin-left: 3px;
          padding-bottom: 3px;
          color: var(--main-color-order);
          border-bottom: 1px solid var(--main-color-order);
          cursor: pointer;
        }
      }
    }
  }
  /* 手机端门票选择 */
  .mainwap {
    width: 100%;
    padding-bottom: 15px;
    border-bottom: 1px solid #e6e6e6;
    .step-2 {
      margin-top: 35px;
      padding-bottom: 50px;
      .info-group {
        width: 100%;
        margin-top: 15px;
        display: flex;
        position: relative;
        z-index: 1;
        --text-line-height: 26px;
        * {
          margin-top: 0;
          margin-bottom: 0;
          line-height: var(--text-line-height);
          font-size: 16px;
        }
        label, button {
          white-space: nowrap;
        }
        label {
          min-width: 75px;
        }
        button {
          width: 90px;
          height: calc(var(--text-line-height) + 4px);
          margin-top: -1px;
          font-size: 13px;
          color: #ffffff;
          position: absolute;
          right: 0;
          z-index: 2;
          border-top-right-radius: 5px;
          border-bottom-right-radius: 5px;
          border: 1px solid #d0d0d0;
          background-color: var(--main-color-order); // #d0d0d0;
        }
        input, textarea {
          width: 100%;
          outline: none;
          border-radius: 5px;
          border: 1px solid #d0d0d0;
        }
        input {
          height: calc(var(--text-line-height) + 2px);
          padding: 0 5px;
          &.code {
            padding-right: 95px;
          }
        }
        textarea {
          height: calc(var(--text-line-height) * 2 + 2px);
        }
      }
    }
  }
  p.step {
    font-size: 18px;
    span {
      display: block;
      width: 100%;
      line-height: 1.4;
      margin-top: 15px;
      font-size: 14px;
      font-weight: 400;
      color: #999999;
    }
  }
  /* FAQ */
  .faq {
    width: 100%;
  }
  .faqz {
    padding: 60px 25px 75px 25px;
    max-width: 1250px;
    margin: 0 auto;
    a {
      color: #131313;
      font-size: 18px;
      margin-top: 70px;
      box-sizing: border-box;
      /* background: url(../assets/hx.png) repeat-x center; */
      font-weight: bold;
      display: inline-block;
    }
  }
  .intro {
    width: 100%;
    background-size: 100%;
    margin-top: 45px;
    box-sizing: border-box;
    background-color: #ffffff;
    padding: 15px 50px 25px 40px;
    border-left: 8px solid var(--main-color-order);
    .title_ts {
      display: -webkit-box;  /* OLD - iOS 6-, Safari 3.1-6 */
      display: -moz-box;     /* OLD - Firefox 19- (buggy but mostly works) */
      display: -ms-flexbox;  /* TWEENER - IE 10 */
      display: -webkit-flex; /* NEW - Chrome */
      display: flex;
      margin-top: 30px;
    }
    .title_ts.title_ts1 {
      margin-top: 0;
    }
    .title_ts h1 {
      /* font-family: 'PingFang SC Regular'; */
      font-size: 16px;
      font-weight: bold;
      line-height: 20px;
      /* margin-left: 10px; */
      color: #131313;
    }
    p {
      /* font-family: 'PingFang SC Regular'; */
      font-size: 15px;
      line-height: 28px;
      text-align: left;
      /* margin-top: 15px; */
      margin-top: 10px;
      color: #999999;
    }
  }
  @media (max-width: 767px) {
    .faq.pc_content {
      padding: 0;
    }
    .faqz {
      /* padding: 0.5rem 25px 45px 25px; */
      max-width: 1160px;
      margin: 0 auto;
    }
    .intro {
      width: 100%;
      /* background: url(../assets/cstand_bg1.png) left top repeat-y; */
      margin-top: 0.8rem;
      /* box-shadow: 0px 0px 10px #edecec; */
      box-sizing: border-box;
      background-color: #ffffff;
      padding: 10px 12px 15px 12px;
    }
    .title_ts {
      display: -webkit-box;  /* OLD - iOS 6-, Safari 3.1-6 */
      display: -moz-box;     /* OLD - Firefox 19- (buggy but mostly works) */
      display: -ms-flexbox;  /* TWEENER - IE 10 */
      display: -webkit-flex; /* NEW - Chrome */
      display: flex;
      margin-top: 0.8rem;
      h1 {
        font-size: 16px;
        font-weight: bold;
        line-height: 16px;
        /* margin-left: 0.3rem; */
      }
    }
    img {
      width: 0.35rem;
      height: 0.45rem;
      vertical-align: top !important;
    }
    p {
      font-size: 12px;
      line-height: 22px;
      text-align: left;
      /* margin-top: 3px; */
      margin-top: 5px;
    }
    .faqz a {
      font-size: 15px;
      margin-top: 30px;
      margin-left: 20px;
      box-sizing: border-box;
      /* background: url(../assets/hx.png) repeat-x center; */
      font-weight: bold;
      display: inline-block;
    }
  }

  /* 覆盖层 */
  .cover-layer {
    display: none;
    width: 100%;
    background: rgba(0, 0, 0, 0.4);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    &.show {
      display: block;
    }
  }
  button {
    background: none;
    border: none;
    width: 100%;
    height: 100%;
    outline: none;
  }
  .login_phone {
    width: 100%;
    padding-top: 110px;
  }
  @media (min-width: 950px) {
    .login_phone {
      margin-top: 120px;
    }
  }
  @media (min-width: 767px) and (max-width: 950px) {
    .login_phone {
      margin-top: 100px;
    }
  }
  @media (max-width: 767px) {
    .login_phone {
      margin-top: 2rem;
      padding-top: 0px;
    }
  }
  .login-close {
    position: absolute;
    width: 100%;
    height: 100%;
    margin-top: -240px;
    background-color: transparent;
  }
  .backbg {
    width: 440px;
    margin: 0 auto;
    border: 1px solid #eeeeee;
    border-radius: 15px;
    background: #ffffff;
    /* height: 100%; */
    height: auto;
    position: fixed;
    left: 50%;
    margin-left: -220px;
    z-index: 10;
    .top {
      text-align: center;
      border-bottom: 1px solid #ececec;
      box-shadow: 0px 0px 3px #ececec;
      border-top-left-radius: 15px;
      border-top-right-radius: 15px;
    }
    .middle {
      padding: 40px 25px;
    }
    .phone_input {
      width: 100%;
      height: 48px;
      line-height: 48px;
      border-radius: 5px;
      border: 1px solid #d9d9d9;
      padding-left: 20px;
      margin-bottom: 14px;
      box-sizing: border-box;
      font-size: 16px;
      outline: none;
    }
    .code {
      display: -webkit-box;  /* OLD - iOS 6-, Safari 3.1-6 */
      display: -moz-box;     /* OLD - Firefox 19- (buggy but mostly works) */
      display: -ms-flexbox;  /* TWEENER - IE 10 */
      display: -webkit-flex; /* NEW - Chrome */
      display: flex;
      justify-content: space-between;
      box-sizing: border-box;
    }
    .code input {
      width: 210px;
      height: 48px;
      line-height: 48px;
      border-radius: 5px;
      outline: none;
      border: 1px solid #d9d9d9;
      padding-left: 20px;
      font-size: 16px;
    }
    .send_code {
      width: 166px;
      height: 48px;
      line-height: 48px;
      font-size: 16px;
      border-radius: 5px;
      border: 1px solid #d9d9d9;
      text-align: center;
      cursor: pointer;
    }
    .login_btn {
      height: 46px;
      line-height: 46px;
      width: 100%;
      border: 2px solid var(--main-color-order);
      margin-top: 27px;
      border-radius: 5px;
      box-shadow: 0px 0px 5px #f8eac9;
      text-align: center;
      font-size: 22px;
      background: none;
    }
    .login_btn button {
      width: 100%;
      height: 46px;
      line-height: 46px;
      cursor: pointer;
      color: #000000;
      background: none;
      border: none;
    }
    .login_btn:hover {
      background: var(--main-color-order);
      transition: all 0.3s;
    }
    .login_btn:active {
      background: #ffd21d;
    }
    .bottom {
      border-bottom-left-radius: 15px;
      border-bottom-right-radius: 15px;
      background: #fffdef;
      padding: 29px 25px 29px 27px;
      display: -webkit-box;  /* OLD - iOS 6-, Safari 3.1-6 */
      display: -moz-box;     /* OLD - Firefox 19- (buggy but mostly works) */
      display: -ms-flexbox;  /* TWEENER - IE 10 */
      display: -webkit-flex; /* NEW - Chrome */
      display: flex;
    }
    .bottom p {
      font-size: 16px;
    }
    .bottom img {
      margin-left: 25px;
      cursor: pointer;
    }
  }

  @media (min-width: 200px) and (max-width: 767px) {
    .banner.mob {
      position: fixed;
      margin-left: 5%;
      z-index: 10;
    }
    .backbg {
      width: 90%;
      margin: 0 auto;
      margin-top: 33.8vw;
      margin-left: 5%;
      left: 0;
      border: 0px;
      border-radius: 0;
      background: #ffffff;
      padding: 1rem 0.6rem;
      .middle {
        padding: 0;
      }
      .phone_input {
        width: 100%;
        height: 1.6rem;
        line-height: 1.6rem;
        border-radius: 0px;
        border: none;
        padding-left: 0.3rem;
        margin-bottom: 0.5rem;
        box-sizing: border-box;
        font-size: 16px;
        outline: none;
        background: #f7f7f7;
      }
      .code {
        display: -webkit-box;  /* OLD - iOS 6-, Safari 3.1-6 */
        display: -moz-box;     /* OLD - Firefox 19- (buggy but mostly works) */
        display: -ms-flexbox;  /* TWEENER - IE 10 */
        display: -webkit-flex; /* NEW - Chrome */
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;
      }
      .code input {
        width: 5.5rem;
        height: 1.6rem;
        line-height: 1.6rem;
        border-radius: 0px;
        outline: none;
        border: none;
        padding-left: 0.3rem;
        font-size: 16px;
        background: #f7f7f7;
      }
      .send_code {
        width: 3.5rem;
        height: 1.6rem;
        line-height: 1.6rem;
        border-radius: 0px;
        font-size: 14px;
        border-radius: 0px;
        border: none;
        text-align: center;
        background: #f7f7f7;
      }
      .login_btn {
        height: 1.6rem;
        line-height: 1.6rem;
        width: 100%;
        border: none;
        margin-top: 0.5rem;
        border-radius: 0px;
        box-shadow: none;
        text-align: center;
        font-size: 16px;
        background: #e1e1e1;
      }
      .login_btn a {
        width: 100%;
        height: 1.6rem;
        line-height: 1.6rem;
        cursor: pointer;
        color: #808080;
      }
      .login_btn a:hover {
        color: #ffffff;
      }
      .login_btn:hover {
        background: var(--main-color-order);
        transition: all 0.3s;
      }
      .login_btn:active {
        background: #ffd21d;
      }
    }
  }

  .dibu {
    margin-top: 40px;
    width: 100%;
    text-align: center;
    img {
      width: 1.6rem;
      margin: 0px 20px;
    }
    p {
      font-size: 0.5rem;
      color: #666666;
      margin-top: 0.5rem;
    }
  }

  /*  */

  .btn_order {
    height: 50px;
    line-height: 50px;
    font-size: 22px !important;
    /* font-family: Adobe Heiti Std!important; */
    font-weight: normal !important;
    color: #000000 !important;
  }

  .pc_content .con {
    padding-top: 60px;
    >h2 {
      font-size: 36px;
      /* font-family: PingFang SC Heavy; */
      font-weight: 800;
      color: #2b2b2b;
      margin: 0;
    }
    .h2::before {
      content: "";
      width: 57px;
      display: block;
      padding-bottom: 15px;
      border-top: 3px solid var(--main-color-order);
    }
    .h2 {
      white-space: nowrap;
      margin: 0;
      margin-top: 15px;
      font-size: 18px;
      /* font-family: PingFang SC Bold; */
      font-weight: bold;
      color: #c1c1c1;
    }
    .h2 span {
      opacity: 0.4;
    }
  }
  @media (max-width: 767px) {
    .pc_content .con {
      padding-top: 40px;
      >h2 {
        font-size: 24px;
      }
      .h2 {
        width: 38px;
        font-size: 12px;
        margin-top: 10px;
        margin-bottom: 35px !important;
        padding-top: 10px;
        border-width: 2px;
      }
    }
  }

  .code-con {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 999;
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    flex-wrap: nowrap;
    .code-box {
      width: 80%;
      max-width: 440px;
      height: 50%;
      max-height: 260px;
      min-height: 200px;
      background: #ffffff;
      border-radius: 8px;
      padding: 30px;
      display: flex;
      justify-content: flex-end;
      align-content: center;
      align-items: center;
      flex-wrap: wrap;
      h1 {
        width: 100%;
        line-height: 1;
        font-size: 24px;
        font-weight: 400;
        margin: 0;
        text-align: left;
        margin-bottom: 18px;
        color: #333;
      }
      input {
        width: 100%;
        height: 48px;
        line-height: 48px;
        font-size: 20px;
        text-align: center;
        padding: 0 15px;
        border: #999 1px solid;
        border-radius: 4px;
        outline: none;
      }
      button {
        width: auto;
        height: auto;
        min-width: 120px;
        line-height: 1;
        padding: 10px 25px;
        margin: 30px 0 0 10px;
        font-size: 18px;
        border-radius: 4px;
        background: var(--main-color-order);
        color: #ffffff;
        border: none;
        &:nth-of-type(1) {
          opacity: .65;
        }
      }
      @media (max-width: 767px) {
        button {
          min-width: fit-content;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/viewsNew/Order.vue